const swiperLoadCache = new Map();

const SWIPER_MODULE_GROUPS = {
  core: () => Promise.resolve({}),
  hero: () => import("./swiper-modules-hero.js"),
  visitenkarten: () => import("./swiper-modules-visitenkarten.js"),
};

const resolveGroup = (requestedGroup) => {
  const key = typeof requestedGroup === "string" ? requestedGroup : "core";
  return SWIPER_MODULE_GROUPS[key] ? key : "core";
};

export async function loadSwiperModule(requestedGroup = "core") {
  const group = resolveGroup(requestedGroup);
  if (!swiperLoadCache.has(group)) {
    const loadPromise = Promise.all([
      import("swiper"),
      SWIPER_MODULE_GROUPS[group](),
    ]).then(([core, modules]) => ({
      Swiper: core.default,
      modules,
    }));
    swiperLoadCache.set(group, loadPromise);
  }
  return swiperLoadCache.get(group);
}
